import "assets/styles/teaser.scss";
import { ReactComponent as IconArrow } from "assets/images/icons/arrow-right.svg";
import Button from "components/ui/Button/Button";
import { useHistory } from "react-router-dom";

function BulletinBoardTeaser({ data }) {
  const history = useHistory();

  return (
    <div className="teaser teaser--wide">
      <div className="teaser__top">
        <div className="teaser__info">
          <h4 className="teaser__title">
            { data.entity.title }
          </h4>

          <div className="teaser__user">
            <span>{ data.author }</span>
            { data.created.long }
          </div>
        </div>

        <div className="teaser__button">
          <Button variant={ 'secondary' }
                  className={ 'button--square' }>
            <IconArrow/>
          </Button>
        </div>
      </div>

      <div className="teaser__intro">
        { data.body.teaser }
      </div>

      <span onClick={ () => history.push(data.entity.url) } className={ 'link-overlay' }></span>
    </div>
  );
}

export default BulletinBoardTeaser;
